import { createFileRoute } from "@tanstack/react-router";
import { LegalPage, legalHead } from "@/components/LegalPage";
import { LegacyPolicyBody } from "@/components/LegacyPolicyBody";
import { legacyPolicies } from "@/data/legacy-policies";

export const Route = createFileRoute("/terms")({
  head: () => {
    const head = legalHead({
      title: "Terms & Conditions | Preserve Earth",
      description:
        "Preserve Earth's website terms of use: cookies, intellectual property, comments, hyperlinking, content liability, removal of links and the disclaimer.",
      path: "/terms",
      crumbName: "Terms & Conditions",
    });
    return { ...head, meta: [...head.meta, { name: "robots", content: "index, follow" }] };
  },
  component: TermsPage,
});

function TermsPage() {
  return (
    <LegalPage
      crumb={{ name: "Terms & Conditions", path: "/terms" }}
      showPolicyContact={false}
      intro={<LegacyPolicyBody blocks={legacyPolicies.terms} />}
    />
  );
}
